import script from "./NavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=1e57501b&scoped=true&lang=css"

import exportComponent from "/home/hugoriveros18/LENGUAJES-DE-PROGRAMACION/JAVASCRIPT/Vue.js/space-tourism-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e57501b"]])

export default __exports__